<template>
  <div>
    <h5 class="display-5">Student</h5>
    <h6 class="display-6">
      Your list student to started take the quiz.Please choose one of the list
      in the following below to start quiz.
    </h6>
    <br /><br />
    <CCard class="h-100" align="center">
      <CCol sm="12" class="justify-content-center">
        <br />
        <div class="float-right">
          <CButton color="success">
            <span @click="GoToPageRegisterStudent">
              + Register New Student</span
            >
          </CButton>
        </div>
        <br /><br />
        <CRow>
          <CCol
            v-for="(item, index) in StudentList"
            v-bind:key="item.Id"
            class="justify-content-center"
            sm="3"
          >
            <br />
            <CRow
              id="sb"
              style="border-radius: 10px; border: 2px solid #eee"
              class="m-0 pt-1 col-12"
              @click="GoStudentDashbboard(item.studentId, item.userId)"
            >
              <CCol class="col-12 pt-2 pb-2">
                <span v-if="item.studentProfilePhoto != ''">
                  <img
                    :src="getPic(index)"
                    width="100px"
                    height="100px"
                    class="box-shadow"
                    style="border-radius: 50%; border: 1px solid #eee"
                  />
                </span>

                <span v-else>
                  <img
                    src="../assets/img/user.png"
                    width="100px"
                    height="100px"
                    class="box-shadow"
                    style="border-radius: 50%; border: 1px solid #eee"
                  />
                </span>
              </CCol>
              <CCol class="col-12 text-center">
                <h6 class="ml-2 mr-2 text-black custom-font text-uppercase">
                  {{ item.studentName }}
                </h6>
                <p class="ml-2 text-black custom-font small">
                  <CBadge color="success">{{ item.gradeName }}</CBadge>
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </CCol>
      <br /><br />
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
//import Mainlayout from "../containers/TheHeaderStudentCustom.vue";

Vue.use(VuejsDialog);

export default {
  name: "Login",

  components: {
    PulseLoader,
    //Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      StudentList: [],
      Error: false,
      SubmittedForm: false,
      ParentProfile: {},
      user: {},
    };
  },

  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetStudentDetails();
      this.GetParentProfile();
    } else {
      this.GoToLogin();
    }
  },

  computed: {},
  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetStudentDetails(this.user.id);
            this.GetParentProfile(this.user.id);
          }
        });
    },
    async GetStudentDetails() {
      this.$API
        .get(this.$StudentList + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentList = response.data;
            this.getPic(this.StudentList.studentProfilePhoto);
            console.log(this.StudentList);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(index) {
      return (
        "https://pickiddo.com" + this.StudentList[index].studentProfilePhoto
      );
    },

    async GetParentProfile() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.ParentProfile = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    async GoStudentDashbboard(studentId, userId) {
      let quizID = this.$route.query.quizId;

      if (quizID == "" || quizID == null || quizID == undefined) {
        this.$router.push(
          "/QuizStudentDashboard?userId=" + userId + "&studentId=" + studentId
        );
      } else {
        this.$router.push(
          "/QuizStudentDescription?quizId=" +
            quizID +
            "&studentId=" +
            studentId +
            "&userId=" +
            userId
        );
      }
    },
    GoToPageRegisterStudent() {
      this.$router.push("/RegisterStudent");

      if (quizID == "" || quizID == null || quizID == undefined) {
        this.$router.push("/RegisterStudent");
      } else {
        this.$router.push("/RegisterStudent?quizId=" + quizID);
      }
    },

    GoToHome() {
      this.$router.push("/student/Mainpage?userId=" + this.$route.query.userId);
    },
  },
};
</script>
